import getters from './getters'
import mutations from './mutations'
import actions from './actions'

const state = {
  isLoaded: false,
  brands: [],
  categories: [],
  subCategories: [],
  itemTypes: [],
  years: [],
  productTypes: [],
  seasons: [],
  markets: [],
  channels: [],
  countries: [],
  divisions: [],
  departments: [],
  classes: [],
  subClasses: [],
  vendors: [],
  mills: [],
  vendorGroups: [],
  searchCriteria: {
    capability: null,
    fabricRdNumber: null,
    indcDate: null,
    brands: null,
    categories: null,
    subCategories: null,
    itemTypes: null,
    year: null,
    season: null,
    markets: null,
    channels: null,
    countries: null,
    divisions: null,
    departments: null,
    classes: null,
    subClasses: null,
    vendors: null,
    mills: null,
    status: null,
    masterStyleNumber: null,
    styleNumber: null,
    styleComplex: null,
    universalStyleNumber: null,
    vendorGroups: null
  }
}

export default {
  state,
  getters,
  mutations,
  actions
}



// WEBPACK FOOTER //
// ./src/components/common/store/index.js